import { get } from 'lodash';

const stringCompare = (r1, r2, key) => String(r1[key]).localeCompare(r2[key]);

const numCompare = (r1, r2, key) => get(r1, key, 0) - get(r2, key, 0);

export { stringCompare, numCompare };
